module.exports = __webpack_public_path__ + "img/f2_1.5e1f056c.png";